import { Link, useMatchRoute, useParams } from '@tanstack/react-router';

import { usePageScroll } from '@libs/hooks/usePageScroll';
import { BackNavButton } from '@ui/components/BackNavButton';
import { useMediaQuery } from '@providers/MediaQueryProvider';

import { ClubLogo } from '@features/club/ui/ClubLogo';
import { SiteLogo } from '@features/shared/ui/SiteLogo/SiteLogo';

import styles from './SiteLogo.module.css';

type Props = {
  clubLogoUrl?: string | null;
};
export function SiteLogoWidget({ clubLogoUrl }: Props) {
  const isMobile = useMediaQuery() === 'mobile';
  const { clubId: routeClubId } = useParams({ strict: false });

  const matchRoute = useMatchRoute();
  const isClubListPage = matchRoute({ to: '/club' });
  const isTournamentListPage = matchRoute({ to: '/tournament' });
  const isTournamentPage = matchRoute({
    to: '/club/$clubId/tournament/$tournamentId',
  });
  const isClubPage = !!matchRoute({ to: '/club/$clubId' });
  const { scrollY, scrollToTop } = usePageScroll();
  const isScrolledToTop = scrollY === 0;

  const isBackToClubButtonVisible =
    routeClubId && clubLogoUrl && (isTournamentPage || (isClubPage && !isScrolledToTop));

  let logoVariant:
    | 'chessopen'
    | 'chessopen-tournaments'
    | 'chessopen-play'
    | 'chessopen-play-monochrome' = 'chessopen-play-monochrome';

  if (isClubListPage || isTournamentListPage) {
    if (isMobile) logoVariant = 'chessopen-play';
    else logoVariant = 'chessopen';
  }

  return (
    <>
      {isBackToClubButtonVisible && (
        <Link
          className={styles.backNavButton}
          to="/club/$clubId"
          params={{ clubId: routeClubId }}
          from="/"
          onClick={isClubPage ? scrollToTop : undefined}
          resetScroll={!isClubPage}
        >
          <BackNavButton title="На карточку клуба">
            <ClubLogo logoUrl={clubLogoUrl} />
          </BackNavButton>
        </Link>
      )}

      <Link to="/" from="/">
        <SiteLogo variant={logoVariant} />
      </Link>
    </>
  );
}
